import React, { Children } from 'react';
import { motion } from 'framer-motion';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.12,
      delayChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
};
export function FinalCTA() {
  return <section className="bg-[#111111] px-5 py-16 md:py-24" data-id="element-21">
      <motion.div className="max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
      once: true,
      margin: '-100px'
    }} data-id="element-22">
        <motion.div variants={itemVariants} className="bg-[#0A0A0A] p-6 md:p-8 rounded-lg border border-[#2A2A2A] mb-12" data-id="element-23">
          <p className="text-white font-semibold text-lg mb-4" data-id="element-24">
            Garantía / Nota (sin promesas)
          </p>
          <p className="text-[#A0A0A0] text-lg leading-relaxed mb-4" data-id="element-25">
            No te voy a prometer resultados.
          </p>
          <p className="text-[#A0A0A0] text-lg leading-relaxed" data-id="element-26">
            Lo que sí te prometo es esto: si tienes tráfico y estás estancado,
            este kit te va a mostrar{' '}
            <span className="text-white" data-id="element-27">exactamente qué puerta está rota</span>{' '}
            y cómo arreglarla sin teoría innecesaria.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="text-center" data-id="element-28">
          <p className="text-[#A0A0A0] text-lg md:text-xl mb-6" data-id="element-29">
            Si quieres dejar de coleccionar vistas y empezar a generar ventas:
          </p>
          <a href="#precio" className="inline-block bg-[#E8732A] hover:bg-[#d4662a] text-white font-bold text-lg md:text-xl px-10 py-5 rounded-lg transition-colors duration-200 mb-8" data-id="element-30">
            Consigue "Vistas ≠ Ventas" ahora →
          </a>
          <p className="text-[#A0A0A0]/60 text-sm" data-id="element-31">
            y aplica el Sprint de 7 días.
          </p>
        </motion.div>

        <motion.div variants={itemVariants} className="mt-16 pt-8 border-t border-[#2A2A2A] text-center" data-id="element-32">
          <p className="text-[#A0A0A0]/40 text-sm" data-id="element-33">
            Para afiliados en español en USA | DM primero | Educación/Cursos
          </p>
        </motion.div>
      </motion.div>
    </section>;
}